export const ASPECT_RATIO_VALUE = {
  square: 1,
  portrait3By4: 3 / 4,
  portrait4By5: 4 / 5,
  portrait5By4HeightMultiplier: 5 / 4,
  story9By16: 9 / 16,
  venueBooking: 16 / 10,
} as const;

export const ASPECT_RATIO_CLASS = {
  square: "aspect-square",
  portrait3By4: "aspect-[3/4]",
  portrait4By5: "aspect-[4/5]",
  story9By16: "aspect-[9/16]",
  venueBooking: "aspect-[16/10]",
  walletCard: "aspect-[1.6/1]",
  eventPaymentLoading: "aspect-[1.65]",
} as const;

export const CSS_ASPECT_RATIO = {
  walletCard: "1.586",
} as const;

/** Instagram-style feed bounds: portrait 4:5 through landscape 1.91:1. */
export const clampFeedMediaAspectRatio = (ratio?: number | null) => {
  if (!ratio || !Number.isFinite(ratio) || ratio <= 0) {
    return ASPECT_RATIO_VALUE.portrait4By5;
  }
  return Math.min(1.91, Math.max(ASPECT_RATIO_VALUE.portrait4By5, ratio));
};
